//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'icon-techbooks',
};
